import axios from "axios";

export default {
  namespaced: true,
  state: {
    countries: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    countriesMessage: ''
  },
  mutations: {
    RECEIVED_COUNTRIES(state, payload) {
      state.countries = payload;
      state.isReceiving = false;
    },
    RECEIVING_COUNTRIES(state) {
      state.isReceiving = true;
    },
    RECEIVED_COUNTRY(state, payload) {
      state = Object.assign(state, {
        countries: [...state.countries, payload],
        isReceiving: false,
      })
    },
    RECEIVING_COUNTRY(state) {
      state.isReceiving = true;
    },
    UPDATED_COUNTRY(state, payload) {
      let index = state.countries.findIndex(country => country._id === payload._id);
      state = Object.assign(state, {
        countries: state.countries.map((country, i) => {
          if (i === index) {
            return Object.assign({}, country, payload);
          }
          return country;
        }),
        isUpdating: false,
        countriesMessage: 'Countries has been updating!',
      })
    },
    UPDATING_COUNTRY(state) {
      state.isUpdating = true;
    },
    DELETED_COUNTRY(state, payload) {
      let indexToDelete = state.countries.findIndex(country => country._id === payload._id);
      let countries = [...state.countries];
      countries.splice(indexToDelete, 1);
      state = Object.assign(state, {
        countries: [...countries],
        isDeleting: false,
        idToDelete: null,
        countriesMessage: 'Country has been Deleted!',
      });
    },
    DELETING_COUNTRY(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    deleteCountryRequest({dispatch}, payload) {
      dispatch("deletingCountry", payload);
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/delete/country/' + payload._id
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      axios({method: "DELETE", url: url, headers: headers}).then(() => {
        dispatch("deleteCountry", {_id: payload._id});
      })
    },
    getCountriesRequest({dispatch}) {
      dispatch("receivingCountries");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/countries';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      axios({method: "GET", url: url, headers: headers})
      .then(res => {
        dispatch("receiveCountries", res.data);
      })
    },
    async insertCountryRequest({dispatch}, payload) {
      dispatch("receivingCountries");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/country/';
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      return axios({method: "post", url: url, headers: headers , data: data})
      .then(response=>{
        dispatch("receiveCountry", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.reponse.data.error;
      });	
    },
    async insertCountryWithImageRequest({dispatch}, payload) {
      dispatch("receivingCountries");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/country/';
      let data = new FormData();
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};

      data.append('image', payload.countryimage, payload.imagename); 
      delete payload['countryimage'];
      for (let x in payload) data.append(x, payload[x]);
      
      return axios({method: "post", url: url, headers: headers , data: data})
      .then(response =>{
        dispatch("receiveCountry", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.reponse.data.error;
      });	
    },
    updateCountryRequest({dispatch}, payload) {
      dispatch("updatingCountry");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/country/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      axios({method: "put", url: url, headers: headers, data: payload})
      .then(response => {
        dispatch("updateCountry", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    updateCountryImageRequest({dispatch}, payload) {
      dispatch("updatingCountry");
      let token = localStorage.getItem('token');
      let id = payload._id;
      delete payload['_id'];
      let url = 'https://api.accountxc.com:3100/update/country/image/' + id;
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
      let data = new FormData();

      data.append('image', payload.countryimage, payload.imagename); 
      delete payload['countryimage'];
      for (let x in payload) data.append(x, payload[x]);

      axios({method: "put", url: url, headers: headers, data: data})
      .then(response => {
        dispatch("updateCountry", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    receiveCountries({commit}, payload) {
      commit("RECEIVED_COUNTRIES", payload)
    },
    receivingCountries({commit}) {
      commit("RECEIVING_COUNTRIES")
    },
    receiveCountry({commit}, payload) {
      commit("RECEIVED_COUNTRY", payload)
    },
    receivingCountry({commit}) {
      commit("RECEIVING_COUNTRY")
    },
    updateCountry({commit}, payload) {
      commit("UPDATED_COUNTRY", payload)
    },
    updatingCountry({commit}) {
      commit("UPDATING_COUNTRY")
    },
    deleteCountry({commit}, payload) {
      commit("DELETED_COUNTRY", payload)
    },
    deletingCountry({commit}, payload) {
      commit("DELETING_COUNTRY", payload)
    }
  },
};
